import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Constants - functions
import { youtubeLink, protocols } from "../../config/constants";
import { validateApplicationProtocol } from "../../config/validateProtocols";
import { GetClinicAndHomeProtocolData } from "../reports/sections/getProtocolData/clinicAndHome";
import { GetAppBasicsProtocolData } from "../reports/sections/getProtocolData/appBasics";
import { GetAppRotationProtocolData } from "../reports/sections/getProtocolData/appRotation";
import { GetAppARProtocolData } from "../reports/sections/getProtocolData/appAR";
import { GetWebHandTrackingProtocolData } from "../reports/sections/getProtocolData/webHandTracking";
import { GetWebFullBodyProtocolData } from "../reports/sections/getProtocolData/webFullBody";
import { GetProtocolData } from "../rgsICU/sections/getProtocolData";
// Components
import {
  PopUpBackground,
  PopUpContainer,
  TitleAndCloseDiv,
  ProtocolTitle,
  CloseButton,
  CloseImg,
  ProtocolVideoIframe,
  DescriptionText,
  DescriptionTitle,
} from "./styles";
// Assets
import IcoClose from "../../assets/icons/btn_close_gray.svg";

const ProtocolVideoPopUp = ({ setIsProtocolVideoShowed, protocolId }) => {
  const [protocolTitle, setProtocolTitle] = useState("");
  const [protocolVideoUrl, setProtocolVideoUrl] = useState("");
  const [protocolDescription, setProtocolDescription] = useState("");
  const [t] = useTranslation("global");

  useEffect(() => {
    let protocolData = {};

    if (validateApplicationProtocol(protocols.clinicAndHome, protocolId)) protocolData = GetClinicAndHomeProtocolData(protocolId);
    if (validateApplicationProtocol(protocols.app.basic, protocolId)) protocolData = GetAppBasicsProtocolData(protocolId);
    if (validateApplicationProtocol(protocols.app.rotation, protocolId)) protocolData = GetAppRotationProtocolData(protocolId);
    if (validateApplicationProtocol(protocols.app.ar, protocolId)) protocolData = GetAppARProtocolData(protocolId);
    if (validateApplicationProtocol(protocols.web.handTracking, protocolId)) protocolData = GetWebHandTrackingProtocolData(protocolId);
    if (validateApplicationProtocol(protocols.web.fullBody, protocolId)) protocolData = GetWebFullBodyProtocolData(protocolId);
    if (validateApplicationProtocol(protocols.icu, protocolId)) protocolData = GetProtocolData(protocolId);

    const { name, description, video } = protocolData;

    if (validateApplicationProtocol(protocols.icu, protocolId)) {
      setProtocolTitle(t(`protocols_${name}`));
      setProtocolDescription(t(`protocols_${description}`));
      setProtocolVideoUrl(`${youtubeLink}/${t(`protocols_${video}`)}`);
    } else {
      setProtocolTitle(t(name));
      setProtocolDescription(t(description));
      setProtocolVideoUrl(`${youtubeLink}/${t(video)}`);
    }
  }, [protocolId, t]);

  const hidePopupAcrossBackground = (e) => {
    e.preventDefault();
    if (Number(e.target.id) === Number(protocolId)) {
      setIsProtocolVideoShowed(false);
    }
  };

  return (
    <PopUpBackground onClick={hidePopupAcrossBackground} id={protocolId}>
      <PopUpContainer>
        <TitleAndCloseDiv>
          <ProtocolTitle>{protocolTitle.toUpperCase()}</ProtocolTitle>
          <CloseButton onClick={() => setIsProtocolVideoShowed(false)}>
            <CloseImg src={IcoClose} alt="ico-close" />
          </CloseButton>
        </TitleAndCloseDiv>
        <ProtocolVideoIframe src={protocolVideoUrl} title="protocolVideoFrame" allowFullScreen></ProtocolVideoIframe>
        <DescriptionText>
          <DescriptionTitle>{t("protocols_descriptionTitle")}: </DescriptionTitle>
          {protocolDescription}
        </DescriptionText>
      </PopUpContainer>
    </PopUpBackground>
  );
};

export default ProtocolVideoPopUp;
